import { useTranslation } from 'react-i18next'

import { ListCardStripe } from '../../../types/listing'

import { Booking, BookingStatus } from '../../../types/booking/booking'

export const isBookingVoided = (booking: Booking) =>
  booking.status === BookingStatus.CANCELED ||
  booking.status === BookingStatus.RESCHEDULED

export const bookingStatusStripe = (booking: Booking): ListCardStripe => {
  const ended = new Date(booking.endTime) <= new Date()

  switch (booking.status) {
    case BookingStatus.PENDING_PAYMENT:
    case BookingStatus.RESCHEDULED:
      return 'warning'
    case BookingStatus.CONFIRMED:
      return ended ? 'neutral' : 'info'
    case BookingStatus.CANCELED:
    default:
      return 'danger'
  }
}

/** Status of a booking; a confirmed booking that has already ended shows as completed. */
export const BookingStatusBadge = ({ booking }: { booking: Booking }) => {
  const { t } = useTranslation('history')
  const ended = new Date(booking.endTime) <= new Date()

  switch (booking.status) {
    case BookingStatus.PENDING_PAYMENT:
      return (
        <span className="badge badge-warning">
          {t('history.status.pending-payment')}
        </span>
      )
    case BookingStatus.CONFIRMED:
      return ended ? (
        <span className="badge badge-secondary">
          {t('history.status.completed')}
        </span>
      ) : (
        <span className="badge badge-info">
          {t('history.status.confirmed')}
        </span>
      )
    case BookingStatus.RESCHEDULED:
      return (
        <span className="badge badge-warning">
          {t('history.status.rescheduled')}
        </span>
      )
    case BookingStatus.CANCELED:
    default:
      return (
        <span className="badge badge-danger">
          {t('history.status.canceled')}
        </span>
      )
  }
}
